import {useTranslation} from 'react-i18next';

export const useKeywordsTranslations = () => {
	return useTranslation('components/keywords');
};
